import { supabase } from '../lib/supabaseClient';
import { RankingsResponse, RankingType } from '../types/rankings';

const RANKINGS_FUNCTION = 'get-rankings';

export async function fetchRankings(type: RankingType): Promise<RankingsResponse> {
  // Supabase URL에서 functions URL 구성
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  if (!supabaseUrl) {
    throw new Error('Supabase URL not configured');
  }
  
  // type 파라미터를 URL에 추가하기 위해 직접 fetch 사용
  const url = new URL(`${supabaseUrl}/functions/v1/${RANKINGS_FUNCTION}`);
  url.searchParams.set('type', type);
  
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session) {
    throw new Error('Unauthorized');
  }

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${session.access_token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(errorData.error || `HTTP ${response.status}`);
  }

  return response.json();
}

